/*!
 * writer.js - buffer writer for bcoin
 * Copyright (c) 2014-2015, Fedor Indutny (MIT License)
 * Copyright (c) 2014-2017, Christopher Jeffrey (MIT License).
 * https://github.com/bcoin-org/bcoin
 */
'use strict';

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var enforce = require('./enforce');

var encoding = require('./encoding');

var EncodingError = require('./error');
/*
 * Constants
 */


var SEEK = 0;
var U8 = 1;
var U16 = 2;
var U16BE = 3;
var U24 = 4;
var U24BE = 5;
var U32 = 6;
var U32BE = 7;
var U40 = 8;
var U40BE = 9;
var U48 = 10;
var U48BE = 11;
var U56 = 12;
var U56BE = 13;
var U64 = 14;
var U64BE = 15;
var I8 = 16;
var I16 = 17;
var I16BE = 18;
var I24 = 19;
var I24BE = 20;
var I32 = 21;
var I32BE = 22;
var I40 = 23;
var I40BE = 24;
var I48 = 25;
var I48BE = 26;
var I56 = 27;
var I56BE = 28;
var I64 = 29;
var I64BE = 30;
var FL = 31;
var FLBE = 32;
var DBL = 33;
var DBLBE = 34;
var VARINT = 35;
var VARINT2 = 36;
var BYTES = 37;
var STR = 38;
var CHECKSUM = 39;
var FILL = 40;
/**
 * Buffer Writer
 */

var BufferWriter = /*#__PURE__*/function () {
  /**
   * Create a buffer writer.
   * @constructor
   */
  function BufferWriter() {
    _classCallCheck(this, BufferWriter);

    this.ops = [];
    this.offset = 0;
  }
  /**
   * Allocate and render the final buffer.
   * @returns {Buffer} Rendered buffer.
   */


  _createClass(BufferWriter, [{
    key: "render",
    value: function render() {
      var data = Buffer.allocUnsafeSlow(this.offset);
      var off = 0;

      var _iterator = _createForOfIteratorHelper(this.ops),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var op = _step.value;

          switch (op.type) {
            case SEEK:
              off += op.value;
              break;

            case U8:
              off = encoding.writeU8(data, op.value, off);
              break;

            case U16:
              off = encoding.writeU16(data, op.value, off);
              break;

            case U16BE:
              off = encoding.writeU16BE(data, op.value, off);
              break;

            case U24:
              off = encoding.writeU24(data, op.value, off);
              break;

            case U24BE:
              off = encoding.writeU24BE(data, op.value, off);
              break;

            case U32:
              off = encoding.writeU32(data, op.value, off);
              break;

            case U32BE:
              off = encoding.writeU32BE(data, op.value, off);
              break;

            case U40:
              off = encoding.writeU40(data, op.value, off);
              break;

            case U40BE:
              off = encoding.writeU40BE(data, op.value, off);
              break;

            case U48:
              off = encoding.writeU48(data, op.value, off);
              break;

            case U48BE:
              off = encoding.writeU48BE(data, op.value, off);
              break;

            case U56:
              off = encoding.writeU56(data, op.value, off);
              break;

            case U56BE:
              off = encoding.writeU56BE(data, op.value, off);
              break;

            case U64:
              off = encoding.writeU64(data, op.value, off);
              break;

            case U64BE:
              off = encoding.writeU64BE(data, op.value, off);
              break;

            case I8:
              off = encoding.writeI8(data, op.value, off);
              break;

            case I16:
              off = encoding.writeI16(data, op.value, off);
              break;

            case I16BE:
              off = encoding.writeI16BE(data, op.value, off);
              break;

            case I24:
              off = encoding.writeI24(data, op.value, off);
              break;

            case I24BE:
              off = encoding.writeI24BE(data, op.value, off);
              break;

            case I32:
              off = encoding.writeI32(data, op.value, off);
              break;

            case I32BE:
              off = encoding.writeI32BE(data, op.value, off);
              break;

            case I40:
              off = encoding.writeI40(data, op.value, off);
              break;

            case I40BE:
              off = encoding.writeI40BE(data, op.value, off);
              break;

            case I48:
              off = encoding.writeI48(data, op.value, off);
              break;

            case I48BE:
              off = encoding.writeI48BE(data, op.value, off);
              break;

            case I56:
              off = encoding.writeI56(data, op.value, off);
              break;

            case I56BE:
              off = encoding.writeI56BE(data, op.value, off);
              break;

            case I64:
              off = encoding.writeI64(data, op.value, off);
              break;

            case I64BE:
              off = encoding.writeI64BE(data, op.value, off);
              break;

            case FL:
              off = encoding.writeFloat(data, op.value, off);
              break;

            case FLBE:
              off = encoding.writeFloatBE(data, op.value, off);
              break;

            case DBL:
              off = encoding.writeDouble(data, op.value, off);
              break;

            case DBLBE:
              off = encoding.writeDoubleBE(data, op.value, off);
              break;

            case VARINT:
              off = encoding.writeVarint(data, op.value, off);
              break;

            case VARINT2:
              off = encoding.writeVarint2(data, op.value, off);
              break;

            case BYTES:
              off += op.data.copy(data, off);
              break;

            case STR:
              off += data.write(op.value, off, op.enc);
              break;

            case CHECKSUM:
              off += op.func(data.slice(0, off)).copy(data, off, 0, 4);
              break;

            case FILL:
              data.fill(op.value, off, off + op.size);
              off += op.size;
              break;

            default:
              throw new Error('Invalid type.');
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (off !== data.length) throw new EncodingError(off, 'Out of bounds write');
      this.destroy();
      return data;
    }
    /**
     * Get size of data written so far.
     * @returns {Number}
     */

  }, {
    key: "getSize",
    value: function getSize() {
      return this.offset;
    }
    /**
     * Seek to relative offset.
     * @param {Number} offset
     */

  }, {
    key: "seek",
    value: function seek(off) {
      enforce(Number.isSafeInteger(off), 'off', 'integer');
      if (this.offset + off < 0) throw new EncodingError(this.offset, 'Out of bounds write');
      this.offset += off;
      this.ops.push(new NumberOp(SEEK, off));
      return this;
    }
    /**
     * Destroy the buffer writer. Remove references to `ops`.
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.ops.length = 0;
      this.offset = 0;
      return this;
    }
    /**
     * Write uint8.
     * @param {Number} value
     */

  }, {
    key: "writeU8",
    value: function writeU8(value) {
      this.offset += 1;
      this.ops.push(new NumberOp(U8, value));
      return this;
    }
    /**
     * Write uint16le.
     * @param {Number} value
     */

  }, {
    key: "writeU16",
    value: function writeU16(value) {
      this.offset += 2;
      this.ops.push(new NumberOp(U16, value));
      return this;
    }
    /**
     * Write uint16be.
     * @param {Number} value
     */

  }, {
    key: "writeU16BE",
    value: function writeU16BE(value) {
      this.offset += 2;
      this.ops.push(new NumberOp(U16BE, value));
      return this;
    }
    /**
     * Write uint24le.
     * @param {Number} value
     */

  }, {
    key: "writeU24",
    value: function writeU24(value) {
      this.offset += 3;
      this.ops.push(new NumberOp(U24, value));
      return this;
    }
    /**
     * Write uint24be.
     * @param {Number} value
     */

  }, {
    key: "writeU24BE",
    value: function writeU24BE(value) {
      this.offset += 3;
      this.ops.push(new NumberOp(U24BE, value));
      return this;
    }
    /**
     * Write uint32le.
     * @param {Number} value
     */

  }, {
    key: "writeU32",
    value: function writeU32(value) {
      this.offset += 4;
      this.ops.push(new NumberOp(U32, value));
      return this;
    }
    /**
     * Write uint32be.
     * @param {Number} value
     */

  }, {
    key: "writeU32BE",
    value: function writeU32BE(value) {
      this.offset += 4;
      this.ops.push(new NumberOp(U32BE, value));
      return this;
    }
    /**
     * Write uint40le.
     * @param {Number} value
     */

  }, {
    key: "writeU40",
    value: function writeU40(value) {
      this.offset += 5;
      this.ops.push(new NumberOp(U40, value));
      return this;
    }
    /**
     * Write uint40be.
     * @param {Number} value
     */

  }, {
    key: "writeU40BE",
    value: function writeU40BE(value) {
      this.offset += 5;
      this.ops.push(new NumberOp(U40BE, value));
      return this;
    }
    /**
     * Write uint48le.
     * @param {Number} value
     */

  }, {
    key: "writeU48",
    value: function writeU48(value) {
      this.offset += 6;
      this.ops.push(new NumberOp(U48, value));
      return this;
    }
    /**
     * Write uint48be.
     * @param {Number} value
     */

  }, {
    key: "writeU48BE",
    value: function writeU48BE(value) {
      this.offset += 6;
      this.ops.push(new NumberOp(U48BE, value));
      return this;
    }
    /**
     * Write uint56le.
     * @param {Number} value
     */

  }, {
    key: "writeU56",
    value: function writeU56(value) {
      this.offset += 7;
      this.ops.push(new NumberOp(U56, value));
      return this;
    }
    /**
     * Write uint56be.
     * @param {Number} value
     */

  }, {
    key: "writeU56BE",
    value: function writeU56BE(value) {
      this.offset += 7;
      this.ops.push(new NumberOp(U56BE, value));
      return this;
    }
    /**
     * Write uint64le.
     * @param {Number} value
     */

  }, {
    key: "writeU64",
    value: function writeU64(value) {
      this.offset += 8;
      this.ops.push(new NumberOp(U64, value));
      return this;
    }
    /**
     * Write uint64be.
     * @param {Number} value
     */

  }, {
    key: "writeU64BE",
    value: function writeU64BE(value) {
      this.offset += 8;
      this.ops.push(new NumberOp(U64BE, value));
      return this;
    }
    /**
     * Write int8.
     * @param {Number} value
     */

  }, {
    key: "writeI8",
    value: function writeI8(value) {
      this.offset += 1;
      this.ops.push(new NumberOp(I8, value));
      return this;
    }
    /**
     * Write int16le.
     * @param {Number} value
     */

  }, {
    key: "writeI16",
    value: function writeI16(value) {
      this.offset += 2;
      this.ops.push(new NumberOp(I16, value));
      return this;
    }
    /**
     * Write int16be.
     * @param {Number} value
     */

  }, {
    key: "writeI16BE",
    value: function writeI16BE(value) {
      this.offset += 2;
      this.ops.push(new NumberOp(I16BE, value));
      return this;
    }
    /**
     * Write int24le.
     * @param {Number} value
     */

  }, {
    key: "writeI24",
    value: function writeI24(value) {
      this.offset += 3;
      this.ops.push(new NumberOp(I24, value));
      return this;
    }
    /**
     * Write int24be.
     * @param {Number} value
     */

  }, {
    key: "writeI24BE",
    value: function writeI24BE(value) {
      this.offset += 3;
      this.ops.push(new NumberOp(I24BE, value));
      return this;
    }
    /**
     * Write int32le.
     * @param {Number} value
     */

  }, {
    key: "writeI32",
    value: function writeI32(value) {
      this.offset += 4;
      this.ops.push(new NumberOp(I32, value));
      return this;
    }
    /**
     * Write int32be.
     * @param {Number} value
     */

  }, {
    key: "writeI32BE",
    value: function writeI32BE(value) {
      this.offset += 4;
      this.ops.push(new NumberOp(I32BE, value));
      return this;
    }
    /**
     * Write int40le.
     * @param {Number} value
     */

  }, {
    key: "writeI40",
    value: function writeI40(value) {
      this.offset += 5;
      this.ops.push(new NumberOp(I40, value));
      return this;
    }
    /**
     * Write int40be.
     * @param {Number} value
     */

  }, {
    key: "writeI40BE",
    value: function writeI40BE(value) {
      this.offset += 5;
      this.ops.push(new NumberOp(I40BE, value));
      return this;
    }
    /**
     * Write int48le.
     * @param {Number} value
     */

  }, {
    key: "writeI48",
    value: function writeI48(value) {
      this.offset += 6;
      this.ops.push(new NumberOp(I48, value));
      return this;
    }
    /**
     * Write int48be.
     * @param {Number} value
     */

  }, {
    key: "writeI48BE",
    value: function writeI48BE(value) {
      this.offset += 6;
      this.ops.push(new NumberOp(I48BE, value));
      return this;
    }
    /**
     * Write int56le.
     * @param {Number} value
     */

  }, {
    key: "writeI56",
    value: function writeI56(value) {
      this.offset += 7;
      this.ops.push(new NumberOp(I56, value));
      return this;
    }
    /**
     * Write int56be.
     * @param {Number} value
     */

  }, {
    key: "writeI56BE",
    value: function writeI56BE(value) {
      this.offset += 7;
      this.ops.push(new NumberOp(I56BE, value));
      return this;
    }
    /**
     * Write int64le.
     * @param {Number} value
     */

  }, {
    key: "writeI64",
    value: function writeI64(value) {
      this.offset += 8;
      this.ops.push(new NumberOp(I64, value));
      return this;
    }
    /**
     * Write int64be.
     * @param {Number} value
     */

  }, {
    key: "writeI64BE",
    value: function writeI64BE(value) {
      this.offset += 8;
      this.ops.push(new NumberOp(I64BE, value));
      return this;
    }
    /**
     * Write float le.
     * @param {Number} value
     */

  }, {
    key: "writeFloat",
    value: function writeFloat(value) {
      this.offset += 4;
      this.ops.push(new NumberOp(FL, value));
      return this;
    }
    /**
     * Write float be.
     * @param {Number} value
     */

  }, {
    key: "writeFloatBE",
    value: function writeFloatBE(value) {
      this.offset += 4;
      this.ops.push(new NumberOp(FLBE, value));
      return this;
    }
    /**
     * Write double le.
     * @param {Number} value
     */

  }, {
    key: "writeDouble",
    value: function writeDouble(value) {
      this.offset += 8;
      this.ops.push(new NumberOp(DBL, value));
      return this;
    }
    /**
     * Write double be.
     * @param {Number} value
     */

  }, {
    key: "writeDoubleBE",
    value: function writeDoubleBE(value) {
      this.offset += 8;
      this.ops.push(new NumberOp(DBLBE, value));
      return this;
    }
    /**
     * Write a varint.
     * @param {Number} value
     */

  }, {
    key: "writeVarint",
    value: function writeVarint(value) {
      this.offset += encoding.sizeVarint(value);
      this.ops.push(new NumberOp(VARINT, value));
      return this;
    }
    /**
     * Write a varint (type 2).
     * @param {Number} value
     */

  }, {
    key: "writeVarint2",
    value: function writeVarint2(value) {
      this.offset += encoding.sizeVarint2(value);
      this.ops.push(new NumberOp(VARINT2, value));
      return this;
    }
    /**
     * Write bytes.
     * @param {Buffer} value
     */

  }, {
    key: "writeBytes",
    value: function writeBytes(value) {
      enforce(Buffer.isBuffer(value), 'value', 'buffer');
      if (value.length === 0) return this;
      this.offset += value.length;
      this.ops.push(new BufferOp(BYTES, value));
      return this;
    }
    /**
     * Write bytes with a varint length before them.
     * @param {Buffer} value
     */

  }, {
    key: "writeVarBytes",
    value: function writeVarBytes(value) {
      enforce(Buffer.isBuffer(value), 'value', 'buffer');
      this.offset += encoding.sizeVarint(value.length);
      this.ops.push(new NumberOp(VARINT, value.length));
      if (value.length === 0) return this;
      this.offset += value.length;
      this.ops.push(new BufferOp(BYTES, value));
      return this;
    }
    /**
     * Copy bytes.
     * @param {Buffer} value
     * @param {Number} start
     * @param {Number} end
     */

  }, {
    key: "copy",
    value: function copy(value, start, end) {
      enforce(Buffer.isBuffer(value), 'value', 'buffer');
      enforce(start >>> 0 === start, 'start', 'integer');
      enforce(end >>> 0 === end, 'end', 'integer');
      enforce(end >= start, 'start', 'integer');
      var buf = value.slice(start, end);
      this.writeBytes(buf);
      return this;
    }
    /**
     * Write string to buffer.
     * @param {String} value
     * @param {String?} enc - Any buffer-supported encoding.
     */

  }, {
    key: "writeString",
    value: function writeString(value, enc) {
      if (enc == null) enc = 'binary';
      enforce(typeof value === 'string', 'value', 'string');
      enforce(typeof enc === 'string', 'enc', 'string');
      if (value.length === 0) return this;
      this.offset += Buffer.byteLength(value, enc);
      this.ops.push(new StringOp(STR, value, enc));
      return this;
    }
    /**
     * Write a 32 byte hash.
     * @param {Hash} value
     */

  }, {
    key: "writeHash",
    value: function writeHash(value) {
      if (typeof value !== 'string') {
        enforce(Buffer.isBuffer(value), 'value', 'buffer');
        enforce(value.length === 32, 'value', '32-byte hash');
        this.writeBytes(value);
        return this;
      }

      enforce(value.length === 64, 'value', '32-byte hash');
      this.writeString(value, 'hex');
      return this;
    }
    /**
     * Write a string with a varint length before it.
     * @param {String}
     * @param {String?} enc - Any buffer-supported encoding.
     */

  }, {
    key: "writeVarString",
    value: function writeVarString(value, enc) {
      if (enc == null) enc = 'binary';
      enforce(typeof value === 'string', 'value', 'string');
      enforce(typeof enc === 'string', 'enc', 'string');

      if (value.length === 0) {
        this.ops.push(new NumberOp(VARINT, 0));
        return this;
      }

      var size = Buffer.byteLength(value, enc);
      this.offset += encoding.sizeVarint(size);
      this.offset += size;
      this.ops.push(new NumberOp(VARINT, size));
      this.ops.push(new StringOp(STR, value, enc));
      return this;
    }
    /**
     * Write a null-terminated string.
     * @param {String|Buffer}
     * @param {String?} enc - Any buffer-supported encoding.
     */

  }, {
    key: "writeNullString",
    value: function writeNullString(value, enc) {
      this.writeString(value, enc);
      this.writeU8(0);
      return this;
    }
    /**
     * Calculate and write a checksum for the data written so far.
     * @param {Function} hash
     */

  }, {
    key: "writeChecksum",
    value: function writeChecksum(hash) {
      if (hash && typeof hash.digest === 'function') hash = hash.digest.bind(hash);
      enforce(typeof hash === 'function', 'hash', 'function');
      this.offset += 4;
      this.ops.push(new FunctionOp(CHECKSUM, hash));
      return this;
    }
    /**
     * Fill N bytes with value.
     * @param {Number} value
     * @param {Number} size
     */

  }, {
    key: "fill",
    value: function fill(value, size) {
      enforce((value & 0xff) === value, 'value', 'byte');
      enforce(size >>> 0 === size, 'size', 'integer');
      if (size === 0) return this;
      this.offset += size;
      this.ops.push(new FillOp(FILL, value, size));
      return this;
    }
  }]);

  return BufferWriter;
}();
/*
 * Helpers
 */


var WriteOp = function WriteOp(type) {
  _classCallCheck(this, WriteOp);

  this.type = type;
};

var NumberOp = /*#__PURE__*/function (_WriteOp) {
  _inherits(NumberOp, _WriteOp);

  var _super = _createSuper(NumberOp);

  function NumberOp(type, value) {
    var _this;

    _classCallCheck(this, NumberOp);

    _this = _super.call(this, type);
    _this.value = value;
    return _this;
  }

  return NumberOp;
}(WriteOp);

var BufferOp = /*#__PURE__*/function (_WriteOp2) {
  _inherits(BufferOp, _WriteOp2);

  var _super2 = _createSuper(BufferOp);

  function BufferOp(type, data) {
    var _this2;

    _classCallCheck(this, BufferOp);

    _this2 = _super2.call(this, type);
    _this2.data = data;
    return _this2;
  }

  return BufferOp;
}(WriteOp);

var StringOp = /*#__PURE__*/function (_WriteOp3) {
  _inherits(StringOp, _WriteOp3);

  var _super3 = _createSuper(StringOp);

  function StringOp(type, value, enc) {
    var _this3;

    _classCallCheck(this, StringOp);

    _this3 = _super3.call(this, type);
    _this3.value = value;
    _this3.enc = enc;
    return _this3;
  }

  return StringOp;
}(WriteOp);

var FunctionOp = /*#__PURE__*/function (_WriteOp4) {
  _inherits(FunctionOp, _WriteOp4);

  var _super4 = _createSuper(FunctionOp);

  function FunctionOp(type, func) {
    var _this4;

    _classCallCheck(this, FunctionOp);

    _this4 = _super4.call(this, type);
    _this4.func = func;
    return _this4;
  }

  return FunctionOp;
}(WriteOp);

var FillOp = /*#__PURE__*/function (_WriteOp5) {
  _inherits(FillOp, _WriteOp5);

  var _super5 = _createSuper(FillOp);

  function FillOp(type, value, size) {
    var _this5;

    _classCallCheck(this, FillOp);

    _this5 = _super5.call(this, type);
    _this5.value = value;
    _this5.size = size;
    return _this5;
  }

  return FillOp;
}(WriteOp);
/*
 * Expose
 */


module.exports = BufferWriter;